module.exports = __webpack_public_path__ + "img/slide_04_en.40f174cf.jpg";